/**
 * Fail-safe activity helper (request 0061 / platform spec SC 0058).
 * Never throws — missing `activity` or transport errors must not break callers.
 */

import { rtLogService, type ActivityInput } from '@rammetec/core'

type ActivityFn = (input: ActivityInput) => void

export function logActivity(input: ActivityInput): void {
  try {
    (rtLogService as { activity?: ActivityFn }).activity?.(input)
  } catch {
    // Telemetry must never break the caller.
  }
}
